/**
 * Resolves the user-facing label for a condition option. Prefers the optional
 * `displayName`, falling back to `name` then `id`. Use this at every display
 * site (dropdowns, narratives, summaries) so the label shown to the user is
 * consistent while `name` continues to be the API/serialization identifier.
 */
export const getOptionLabel = (
  option?: { displayName?: string; name?: string; id?: string } | null,
): string => option?.displayName ?? option?.name ?? option?.id ?? "";
